import utilRouter from "@/libs/util.router.js";
const config = {
  navMenuConfig: {
    title: "广东轻工职业技术学院人民数字马院",
    menuBackgroundColor: "#b72f33",
    menuTextColor: "#fff",
    menuActiveTextColor: "#b72f33",
  },
  relationId: "2679",
  menuList: [],
  menus: [{
    id: 1,
    title: "通知新闻",
    type: 1,
    menuId: 1723
  }, {
    id: 2,
    title: "政策文件",
    type: 2,
    menuId: 1724
  }, {
    id: 3,
    title: "数字红馆",
    type: 2,
    menuId: 1725
  }],
  breadConfig: {
    Icon: "",
    firstBreTitle: "首页",
    separator: ">",
    breadTitle: "文章详情",
  },
};
config.isNewsActive=function isNewsActive(params) {
  var rules = [
    {
      path: "/kcsz/news/:menuId",
      params: {
        menuId:params.menuId,
      },
      query:{
        type:params.type,
      }
    },
    {
      path: "/kcsz/newsContent/:menuId/:id",
      params: {
        menuId:params.menuId,
      }
    }
  ];

  return function(route) {
    return utilRouter.isMatch(route, rules);
  };
}
config.isCampusDynamicActive=function isCampusDynamicActive(label) {
  var rules = [
    {
      path: "/kcsz/campusDynamic",
    },
    {
        path: "/kcsz/news/:menuId",
        query:{
          label:label
        },
      },
      {
        path: "/kcsz/newsContent/:menuId/:id",
        query:{
          label:label
        },
      }
  ];

  return function(route) {
    return utilRouter.isMatch(route, rules);
  };
}
config.isResultsShowActive=function isResultsShowActive(label) {
  var rules = [
    {
      path: "/kcsz/resultsShow",
    },
    {
      path: "/kcsz/news/:menuId",
      query:{
        label:label
      },
    },
    {
      path: "/kcsz/newsContent/:menuId/:id",
      query:{
        label:label
      },
    }
  ];

  return function(route) {
    return utilRouter.isMatch(route, rules);
  };
}
config.isSystemFileShowActive=function isSystemFileShowActive(label) {
  var rules = [{
    path: "/kcsz/systemFile",
  },{
    path: "/kcsz/news/:menuId",
    query:{
      label:label
    },
  },
  {
    path: "/kcsz/newsContent/:menuId/:id",
    query:{
      label:label
    },
  }];

  return function (route) {
    return utilRouter.isMatch(route, rules)
  }
}
// function isCourseActive(id) {
//   var rules = [{
//     path: "/tjxd/courses/:id",
//     params: {
//       id: id
//     }
//   }];
//   return function (route) {
//     return utilRouter.isMatch(route, rules)
//   }
// }
// function isElaborateActive(id) {
//   var rules = [{
//     path: "/tjxd/elaborate/:declareType",
//     params: {
//       declareType: id
//     }
//   }];
//   return function (route) {
//     return utilRouter.isMatch(route, rules)
//   }
// }
// function isSchoolLevelActive(id) {
//   var rules = [{
//     path: "/tjxd/schoolLevel/:declareType",
//     params: {
//       declareType: id
//     }
//   }];
//   return function (route) {
//     return utilRouter.isMatch(route, rules)
//   }
// }

export default config;
